import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  lancamentos: [],
  planos: []
}

const mutations = {
  atualizarLancamentos(state, payload) {
    state.lancamentos = payload;
    state.lancamentos = state.lancamentos.map(item => { return item.lancamento });
    state.lancamentos = state.lancamentos.map(item => { return { ...item, selecionado: false }});
  },
  selecionarTodos(state) {
    state.lancamentos = state.lancamentos.map(item => { return { ...item, selecionado: true }});
  },
  deselecionarTodos(state) {
    state.lancamentos = state.lancamentos.map(item => { return { ...item, selecionado: false }});
  },
  atualizarPlanos(state, payload) {
    state.planos = payload;
  },
}

const actions = {
  listarLancamentos(context, payload) {
    return axios.post(URLS.LISTAR_LANCAMENTOS_REMESSA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLancamentos', response.data.lista)
          return response.data
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarLancamentos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarContas(context, payload) {
    return axios.post(URLS.CONTAS_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarContas', payload);
            }            
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarPlanos(context, payload) {
    return axios.post(URLS.CONTAS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarPlanos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarPlanos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarPlanos', []);
          return response.data;
      }
    });
  },

  recuperarNumeroRemessa(context, payload) {
    return axios.post(URLS.REMESSAS_FINANCEIRO_RECUPERAR_NUMERO_REMESSA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarNumeroRemessa', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarRemessa(context, payload) {
    return axios.post(URLS.REMESSAS_FINANCEIRO_GERAR_ARQUIVO_REMESSA, payload)
    .then((response) => {
      return response
    }).catch((error) => {
      throw error;
    })
  },
  
  selecionarTodos(context) {
    context.commit('selecionarTodos');
  },
  deselecionarTodos(context) {
    context.commit('deselecionarTodos');
  }
}

export default {
  state,
  mutations,
  actions
}